import {
    DateTime
} from 'luxon';
import TimeRange from '../getTimeRange';
const numeral = require('numeral');
const dateTimeHashMap = new TimeRange().dateTimeHashMap;

export default function kpiText(rawData, timeSelectorValue) {
    let startDate = dateTimeHashMap[timeSelectorValue]['startDate'],
        endDate = dateTimeHashMap[timeSelectorValue]['endDate'],
        startDateInDateTime = DateTime.fromFormat(startDate, 'M/d/yy H:mm'),
        endDateInDateTime = DateTime.fromFormat(endDate, 'M/d/yy H:mm'),
        diffInDays = Math.floor(endDateInDateTime.diff(startDateInDateTime, 'days').values.days),
        shipmentCount = new Array(diffInDays + 1).fill(0),
        grossShipmentCount = 0;
    for (let i = 0; i < rawData.length; i++) {
        let numberOfDaysFromStart = Math.floor(DateTime.fromMillis(rawData[i]['expectedShipDate'], 'M/d/yy H:mm').diff(startDateInDateTime, 'days').values.days);
        shipmentCount[numberOfDaysFromStart] += 1;
    }
    for (let j = 1; j < shipmentCount.length; j++) {
        grossShipmentCount += shipmentCount[j]
    }
    if (grossShipmentCount) {
        return numeral(grossShipmentCount).format(0,0);
    }
}


// WEBPACK FOOTER //
// ./src/util/dataSourceGenerators/totalShipmentText.js